import React, { useContext } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';
import { Picture } from '@comparethemarketau/manor-picture';

const useStyles = createUseStyles((theme) => ({
    size: {
        width: '11.9rem',
        height: '4.9rem'
    }
}));

const SecurityLogo = ({ className }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <div className={className}>
            <Link
                underline="none"
                target="_blank"
                trackingLabel="link for https://www.mcafeesecure.com/verify?host=www.comparethemarket.com.au"
                href="https://www.mcafeesecure.com/verify?host=www.comparethemarket.com.au"
            >
                <Picture
                    className={classNames(classes.size)}
                    alt="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams"
                    title="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams"
                    src="//cdn.ywxi.net/meter/www.comparethemarket.com.au/101.gif"
                />
            </Link>
        </div>
    );
};

SecurityLogo.propTypes = {
    className: PropTypes.string
};

export { SecurityLogo };
